import { Navigate, useRoutes, Outlet } from 'react-router-dom';
import MainLayout from 'src/layouts/main';

import LandingLayout from 'src/LandingUi/LandingLayout';
import MainDomainOnly from 'src/auth/guard/MainDomainOnly';
import TenantDomainOnly from 'src/auth/guard/TenantDomainOnly';
import { isTenantDomain } from 'src/utils/domainContext';
import ReleaseNotesPage from 'src/pages/ReleaseNotesPage';
import { mainRoutes, HomePage } from './main';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './dashboard';
import { componentsRoutes } from './components';
import { onboardRoutes } from './onboardRoutes';
import { policyRoutes } from './policyRoutes';
import  PricingComparisonPage  from '../../LandingUi/screens/PricingComparisonTable';


// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // ── MAIN-DOMAIN-ONLY routes ──────────────────────
    // Landing page, onboard, policy, marketing pages
    {
      path: '/',
      element: isTenantDomain() ? (
        <Navigate to="/auth/jwt/login" replace />
      ) : (
        <MainDomainOnly>
          <LandingLayout />
        </MainDomainOnly>
      ),
    },
    {
      path: '/pricing-comparison',
      element: <PricingComparisonPage />,
    },

    {
      path: '/release-notes',
      element: <ReleaseNotesPage />,
    },

    ...onboardRoutes.map((route) => ({
      ...route,
      element: <MainDomainOnly>{route.element || <Outlet />}</MainDomainOnly>,
    })),

    ...policyRoutes.map((route) => ({
      ...route,
      element: <MainDomainOnly>{route.element || <Outlet />}</MainDomainOnly>,
    })),

    // ── TENANT-DOMAIN-ONLY routes ────────────────────
    // Auth + Dashboard — require a valid tenant subdomain

    ...authRoutes.map((route) => ({
      ...route,
      element: <TenantDomainOnly>{route.element || <Outlet />}</TenantDomainOnly>,
    })),

    ...dashboardRoutes.map((route) => ({
      ...route,
      element: <TenantDomainOnly>{route.element || <Outlet />}</TenantDomainOnly>,
    })),

    // ── SHARED routes (accessible on both domains) ───
    // Main routes include 404, 500, candidateForm, etc.
    ...mainRoutes,

    // Components routes
    ...componentsRoutes,

    // Auth demo routes
    ...authDemoRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
